import React, { useCallback } from 'react';

import { Grid } from '@gogame/components';
import { FormField, withForm, SidePageV2 } from '@gogame/form';

import { loadCategories } from 'scenes/Influencers/InfluencersChannels/sources/fields';

import { NAME, PARENT_CATEGORY, DESCRIPTION } from './constants';
import { CategoryFormValidationSchema } from './schemas';

const CategoryForm = withForm({
  validationSchema: CategoryFormValidationSchema,
  enableReinitialize: true,
})(
  ({
    id,
    children,
    title,
    loading,
    isSubCategory,
    onClose,
    onExited,
    open,
  }) => {
    const handlerLoadCategories = useCallback(() => {
      return loadCategories({ omitId: id });
    }, [id]);

    return (
      <SidePageV2
        onClose={onClose}
        onExited={onExited}
        open={open}
        loading={loading}
        size={'sm'}
      >
        <SidePageV2.Title title={title} />
        <SidePageV2.NewBody>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <FormField.TextField
                label={'Name'}
                name={NAME}
                required={true}
                padding={0}
              />
            </Grid>
            <Grid item xs={12}>
              <FormField.Select
                label={'Parent category'}
                name={PARENT_CATEGORY}
                source={handlerLoadCategories}
                disabled={isSubCategory}
                padding={0}
                lazy={true}
              />
            </Grid>
            <Grid item xs={12}>
              <FormField.TextField
                multiline={true}
                minRows={1}
                label={'Description'}
                name={DESCRIPTION}
                padding={0}
              />
            </Grid>
          </Grid>
        </SidePageV2.NewBody>
        <SidePageV2.Actions>
          <SidePageV2.CloseButton />
          <SidePageV2.SubmitButton />
        </SidePageV2.Actions>
        {children}
      </SidePageV2>
    );
  }
);

export default CategoryForm;
